(function () {
    "use strict";

    angular.module("app").controller("NotificationsController", NotificationsController);

    NotificationsController.$inject = ["$scope", "$document", "webApiServices", "loadingIndicatorService", "notificationsService", "$timeout", "notificationReplyService", "HabilUrlParser", "$window",];
    function NotificationsController($scope, $document, webApiServices, loadingIndicatorService, notificationsService, $timeout, notificationReplyService, HabilUrlParser, $window) {
        $scope.markAsRead = markAsRead;
        $scope.markAsUnread = markAsUnread;

        $scope.delete = deleteNotification;
        $scope.open = notificationsService.Open;
        $scope.reply = reply;

        $scope.showOnlyForeign = false;
        $scope.showOnlyNonForeign = false;

        $scope.unreadNotifications = [];
        $scope.readNotifications = [];

        $scope.getAllNotifications = getAllNotifications;
        $scope.getAllUnreadNotifications = getAllUnreadNotifications;
        $scope.getAllReadNotifications = getAllReadNotifications;

        $scope.allReadNotificationsLoaded = false;

        this.$onDestroy = function () {
            $scope.subscription.dispose();
        };

        function reply(notification) {
            notificationReplyService.set(notification);
        }

        function sortByDate(notifications) {
            return notifications.sort((a, b) => new Date(b.DateTime).getTime() - new Date(a.DateTime).getTime());
        }

        function clearRow(selector, index) {
            const nodes = $document[0].querySelectorAll(selector);
            const node = nodes[index];
            setAnimation(node, "fadeOut", "1s");
        }

        function markAsRead(notification) {
            const idx = $scope.unreadNotifications.indexOf(notification);
            clearRow(`div[name="unreadNotificationRow"]`, idx);

            $scope.unreadNotifications.splice(idx, 1);

            $scope.readNotifications = sortByDate([notification, ...$scope.readNotifications]);

            notificationsService.set($scope.unreadNotifications);

            webApiServices.SetReadStateOnNotification({ Notification: notification, ReadState: true });
        }

        function markAsUnread(notification) {
            notification.ReadOn = null;
            notification.ReadBy = null;

            const idx = $scope.readNotifications.indexOf(notification);
            clearRow(`div[name="readNotificationRow"]`, idx);

            $scope.readNotifications.splice(idx, 1);

            $scope.unreadNotifications = sortByDate([notification, ...$scope.unreadNotifications]);

            notificationsService.set($scope.unreadNotifications);

            webApiServices.SetReadStateOnNotification({ Notification: notification, ReadState: false });
        }

        $scope.shouldHandleNotificationIdParameter = true;

        function getAllNotifications() {
            // Don't use the notifications that are stored in notificationsService, this can cause that a notification shown as both read and unread
            //$scope.subscription = notificationsService.subscribe(notifications => {
            //    $scope.unreadNotifications = notifications;

            //    if ($scope.shouldHandleNotificationIdParameter)
            //        handleNotificationIdParameter(notifications);
            //});

            getAllUnreadNotifications();
            getAllReadNotifications();
        }

        function getAllUnreadNotifications() {
            webApiServices.GetNotifications(
                { ReadState: false, ShowOnlyForeign: $scope.showOnlyForeign, ShowOnlyNonForeign: $scope.showOnlyNonForeign },
                r => {
                    $scope.unreadNotifications = r.data;
                    if ($scope.shouldHandleNotificationIdParameter)
                        handleNotificationIdParameter();
                },
                angular.noop,
                () => loadingIndicatorService.SetLoadingState(false)
            );
        }

        function getAllReadNotifications() {
            webApiServices.GetNotifications(
                { ReadState: true, ShowOnlyForeign: $scope.showOnlyForeign, ShowOnlyNonForeign: $scope.showOnlyNonForeign },
                r => {
                    $scope.readNotifications = r.data;

                    $scope.allReadNotificationsLoaded = true;
                },
                angular.noop,
                () => loadingIndicatorService.SetLoadingState(false)
            );
        }

        function handleNotificationIdParameter() {
            const params = HabilUrlParser.Parse($window.location);

            if (params?.parameters?.id) {
                let id = parseInt(params.parameters.id);
                if (isNaN(id))
                    throw Error("Param id not correct!");

                const notificationToOpen = $scope.unreadNotifications.filter(x => x.Id === id)[0];
                if (!notificationToOpen)
                    return;

                notificationToOpen.ShouldOpen = true;

                function focusOnNotification() {
                    const targetTop = $($(`#unread-panel-${notificationToOpen.Id}`)[0]).offset().top;
                    $("html,body").animate({ scrollTop: targetTop - 50 });
                }

                $timeout(() => focusOnNotification(), "slow");

                $scope.shouldHandleNotificationIdParameter = false;
            }
        }

        function deleteNotification(notification) {
            const idx = $scope.readNotifications.indexOf(notification);
            $scope.readNotifications.splice(idx, 1);

            webApiServices.DeleteNotification({ Notification: notification });
        }

        function setAnimation(element, name, duration) {
            if (!element)
                return;
            element.style.animationName = name;
            element.style.animationDuration = duration;
        }

        getAllUnreadNotifications();
    }
})();